






























































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class CustomerActionsMobile extends Vue {
  @Prop({ default: "" }) readonly customerId!: string;
}
